$(function populateGAClientId() {
    var cookies = document.cookie.trim()
        .split('; ')
        .map(function (line) { return line.split(','); })
        .reduce(function (props, line) {
            var name = line[0].slice(0, line[0].search('='));
            var value = line[0].slice(line[0].search('=') + 1);
            props[name] = value;
            return props;
        }, {})

    var clientId = cookies._gaclientid;

    $('.gaClientId').val(clientId);
});